import { render, staticRenderFns } from "./BoxThree.vue?vue&type=template&id=31cf83e2&scoped=true"
import script from "./BoxThree.vue?vue&type=script&lang=js"
export * from "./BoxThree.vue?vue&type=script&lang=js"
import style0 from "./BoxThree.vue?vue&type=style&index=0&id=31cf83e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf83e2",
  null
  
)

export default component.exports